module.exports = __webpack_public_path__ + "re.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/re.svg
// module id = 1033
// module chunks = 0